import request from "../../../../helper/request";

const locationsApi = {
  getLocationsList: async (params) => {
    const response = await request.get("admin/saved-locations", {
      params: {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        search: params.search || "",
        clientName: params.clientName || ""
      }
    });
    return response.data;
  },

  getLocationById: async (locationId) => {
    const response = await request.get(`admin/saved-locations/${locationId}`);
    return response;
  },

  updateLocation: async ({ locationId, ...data }) => {
    const response = await request.patch(`admin/saved-locations/${locationId}`, data);
    return response.data;
  }
};

export default locationsApi;
